import * as pdfjsLib from "pdfjs-dist";
import * as PDFJS from "pdfjs-dist/web/pdf_viewer.mjs";

pdfjsLib.GlobalWorkerOptions.workerSrc = "/js/pdf.worker.min.mjs";

export default class Pdf {
    loadingTask
    options
    main
    main2

    _doc
    _pages
    _numPages


    constructor(options) {
        this.options = {...{
                container: false,
                viewer: false,
                src: null,
                openPage: 1,
                canvas: $('<canvas>')

            }, ...options}

        this.main = (this.options.container || $('<div>').addClass('PDFContainer') ).append(this.options.canvas)
        this.main2 = (this.options.viewer || $('<div>').addClass('PDFViewer') ).append()

// console.log('XX1',new PDFJS.EventBus())
// console.log('XXZ', new PDFJS.PDFSinglePageViewer({
//     container: this.main[0],
//     viewer:this.main2[0],
//     eventBus: new PDFJS.EventBus()
// }))
//         return
        this.loadingTask = pdfjsLib.getDocument(options.src)
        console.log('PDF task',this.loadingTask)

        this.loadingTask.promise.then((doc) => {
            doc.getPageLayout().then(function (data) {
                console.log("# Metadata Is Loaded");
                console.log("## Info");
                console.log(JSON.stringify(data, null, 2));
                console.log('------------');

            });

            doc.getPage(this.options.openPage).then((page) => {

                console.log('PDF page',page)

                const scale = this.main.width() / page.getViewport({ scale:1 }).width
                const viewport = page.getViewport({ scale });
                // Support HiDPI-screens.
                const outputScale = window.devicePixelRatio || 1;

                //
                // Prepare canvas using PDF page dimensions
                //
                const canvas = this.options.canvas[0]//document.getElementById("the-canvas");
                const context = canvas.getContext("2d");

                canvas.width = Math.floor(viewport.width * outputScale);
                canvas.height = Math.floor(viewport.height * outputScale);
                canvas.style.width = Math.floor(viewport.width) + "px";
                canvas.style.height = Math.floor(viewport.height) + "px";

                console.log('PDF Canvas',this.main.width() , this.main.height(),viewport, scale, outputScale, canvas)

                const transform = outputScale !== 1
                    ? [outputScale, 0, 0, outputScale, 0, 0]
                    : null;

                //
                // Render PDF page into canvas context
                //
                const renderContext = {
                    canvasContext: context,
                    transform,
                    viewport,
                };
                page.render(renderContext);
            })

        })
        //
        // Fetch the first page
        //

        // console.log('!!!??>',pdf,page)



            // .promise
            // .then( (doc) => {
//
// const page = await doc.getPage(1)
//                 this._numPages = doc.numPages
                // this._doc = doc
                //     console.log('==??>',doc.openPage(1))
                //
                // this.loadPage(this.options.openPage)

            //
            //     console.log("# Document Loaded");
            //     console.log("Number of Pages: " + numPages);
            //     console.log();
            //
            //     let lastPromise; // will be used to chain promises
            //     lastPromise = doc.getMetadata().then(function (data) {
            //         console.log("# Metadata Is Loaded");
            //         console.log("## Info");
            //         console.log(JSON.stringify(data.info, null, 2));
            //         console.log();
            //         if (data.metadata) {
            //             console.log("## Metadata");
            //             console.log(JSON.stringify(data.metadata, null, 2));
            //             console.log();
            //         }
            //     });
            //
            //     const loadPage = function (pageNum) {
            //         return doc.getPage(pageNum).then(function (page) {
            //             console.log("# Page " + pageNum);
            //             const viewport = page.getViewport({ scale: 1.0 });
            //             console.log("Size: " + viewport.width + "x" + viewport.height);
            //             console.log();
            //             return page
            //                 .getTextContent()
            //                 .then(function (content) {
            //                     // Content contains lots of information about the text layout and
            //                     // styles, but we need only strings at the moment
            //                     const strings = content.items.map(function (item) {
            //                         return item.str;
            //                     });
            //                     console.log("## Text Content");
            //                     console.log(strings.join(" "));
            //                     // Release page resources.
            //                     page.cleanup();
            //                 })
            //                 .then(function () {
            //                     console.log();
            //                 });
            //         });
            //     };
            //     // Loading of the first page will wait on metadata and subsequent loadings
            //     // will wait on the previous pages.
            //     for (let i = 1; i <= numPages; i++) {
            //         lastPromise = lastPromise.then(loadPage.bind(null, i));
            //     }
            //     return lastPromise;
            // })
            // .then(
            //     function () {
            //         console.log("# End of Document");
            //     },
            //     function (err) {
            //         console.error("Error: " + err);
            //     }
            // );
    }

    render(){

    }

    loadPage(pageNum){
        this._doc.openPage(pageNum).then( (page) => {
            const viewport = page.getViewport({ scale });
            // Support HiDPI-screens.
            const outputScale = window.devicePixelRatio || 1;

            //
            // Prepare canvas using PDF page dimensions
            //
            const canvas = this.options.canvas[0]//document.getElementById("the-canvas");
            const context = canvas.getContext("2d");

            canvas.width = Math.floor(viewport.width * outputScale);
            canvas.height = Math.floor(viewport.height * outputScale);
            canvas.style.width = Math.floor(viewport.width) + "px";
            canvas.style.height = Math.floor(viewport.height) + "px";

            const transform = outputScale !== 1
                ? [outputScale, 0, 0, outputScale, 0, 0]
                : null;

            //
            // Render PDF page into canvas context
            //
            const renderContext = {
                canvasContext: context,
                transform,
                viewport,
            };
            page.render(renderContext);
        })

    }

    get html(){
        return $('<div>').append(this.main, this.main2)
    }
}
